<ng-template #popTemplate
  ><div class="tooltip-content" [innerHtml]="tag.description"></div
></ng-template>
<span
  *ngIf="tag"
  class="rr-tag"
  [tooltip]="popTemplate"
  [isDisabled]="!tag.description"
  [ngStyle]="{
    'background-color': tag.color || undefined,
    color: getTextColor()
  }"
>
  <span class="tag-text" (click)="onTagClicked()">{{ getTagText() }}</span>
  <span
    *ngIf="showRemoveButton"
    class="oi oi-x"
    (click)="onRemoveTagClicked()"
  ></span>
</span>
